import { routePaths } from 'utils/constants';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/contexts/AuthContext';
import { useSelector } from 'react-redux';
import { orgSelector } from 'src/redux/selectors';

const MyTripsMenu = () => {
   const navigate = useNavigate();
   const [t] = useTranslation();
   const { isAuthenticated } = useAuth();
   const { organization } = useSelector(orgSelector);
   const configuration = organization?.configuration;
   return (isAuthenticated && (
      <div
         className='cursor-pointer hidden md:flex'
         onClick={e => {
            e.preventDefault();
            navigate(routePaths.MY_TRIPS);
         }}
      >
         <span className={`text-sm font-semibold text-nowrap ${configuration?.color?.headerText ? `text[${configuration?.color?.headerText}]`: 'text-black' }`}>{t('navbar.myTrips')}</span>
      </div>
   ))
}

export default MyTripsMenu;
